<template>
  <form @submit.prevent="onSubmit">
    <div class="form-row align-items-center">
      <div class="col-auto">
        <label class="sr-only" for="name">Название</label>
        <input
            class="form-control mb-2"
            id="name"
            v-model="local.name"
            type="text"
            placeholder="Название"
        >
      </div>
      <div class="text-danger g-3 mt-3 d-flex justify-content-center align-items-center" v-if="props.errorMessage">
        <span>{{ props.errorMessage }}</span>
      </div>
      <div class="col-auto g-3 mt-3">
        <button class="btn btn-primary mb-2" type="submit">
          Сохранить
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>

import {reactive} from "vue";
const props = defineProps({
  initial: {type: Object, required: false },
  errorMessage: {type: String, required: false },
});

const local = reactive({
  id: props.initial.id ?? '',
  name: props.initial.name ?? '',
});

const emit = defineEmits(['submit']);

function onSubmit() {
  emit('submit', {...local});
}
</script>
